import { gql } from "@apollo/client";

// TODO QUERY
export const FETCH_USER_TRACKING = gql`
  query fetchUserTracking {
    getUserTrackingData {
      dailyStreak
      streakRecord
      emotionsTracked
    }
  }
`;

export const FETCH_USER_TRACKING_RANGE = gql`
  query fetchLoginTracker($startDay: Date!, $endDay: Date!, $staffId: ID!) {
    loginTrackers: loginTrackers_connection(
      filters: {
        day: { gte: $startDay, lte: $endDay }
        staff: { documentId: { eq: $staffId } }
      }
    ) {
      data {
        attributes {
          streakCounter
          day
        }
      }
    }
  }
`;
